import { api } from '../api';
import { invalidator, tags } from '../tags';
import type { ApiError, Copilot } from '../types';

export const copilotApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    createChat: builder.mutation<Copilot, Copilot>({
      query: ({ account_id, messages }) => ({
        url: 'api/copilot/',
        method: 'POST',
        body: { account_id, messages },
      }),
      invalidatesTags: [tags.user],
      extraOptions: { maxRetries: 1 }, // Don't retry as much as others. This can be a long-running request.
    }),
    updateChat: builder.mutation<Copilot, Copilot & { id: string }>({
      query: ({ id, ...patch }) => ({
        url: `api/copilot/${id}/`,
        method: 'PUT',
        body: patch,
      }),
      invalidatesTags: (
        result: Copilot | void,
        error: ApiError | undefined,
        args: Partial<Copilot> & { id: string }
      ) => {
        return [
          ...invalidator<Copilot, Partial<Copilot> & { id: string }>(tags.account, undefined, 'id')(
            result,
            error,
            args
          ),
          tags.levelup,
        ];
      },
      extraOptions: { maxRetries: 1 }, // Don't retry as much as others. This can be a long-running request.
    }),
    updateMessageFeedback: builder.mutation({
      query: ({ messageId, conversationId, messageFeedback }) => ({
        url: `api/copilot/${conversationId}/message/${messageId}/`,
        method: 'PATCH',
        body: {
          user_sentiment: messageFeedback.userSentiment,
          response_types: messageFeedback.responseTypes.join(','),
          feedback: messageFeedback.feedback,
        },
      }),
    }),
  }),
});
